import AuthData from './component';

export default AuthData;
